import React, { useState, useEffect } from "react";
import { TESTIMONIALS_ENABLED } from "../config/promoConfig";

export const Testimonials = (props) => {
  const [dynamicEnabled, setDynamicEnabled] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  // Fetch current state from API
  useEffect(() => {
    const fetchTestimonialsState = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/static-config/testimonials`);
        const result = await response.json();
        if (result.success) {
          setDynamicEnabled(result.data.enabled);
        }
      } catch (err) {
        // If API fails, fall back to static config
        console.warn('Failed to fetch dynamic testimonials config, using static fallback');
      }
    };
    
    fetchTestimonialsState();
    
    // Poll every 5 seconds to check for changes
    const interval = setInterval(fetchTestimonialsState, 5000);
    return () => clearInterval(interval);
  }, [API_BASE_URL]);

  // Use dynamic state if available, otherwise fall back to static config
  const TESTIMONIALS_SECTION_ENABLED = dynamicEnabled !== null ? dynamicEnabled : TESTIMONIALS_ENABLED;

  // If testimonials are disabled, return null (completely hidden)
  if (!TESTIMONIALS_SECTION_ENABLED) return null;

  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Testimonials</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6 col-xs-12">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>{d.text}</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
